<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-3">aaa</div>
            <div class="col-sm-9">
                <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover text-center">
                    <thead>
                        <tr class="boundary">
                            <th scope="col" class="result-tbl-width" nowrap>種目<br>番号</th>
                            <th scope="col" class="result-tbl-width" nowrap>予定<br><span class="court">コート</span></th>
                            <th scope="col" colspan="2">選手</th>
                            <th scope="col" class="result-tbl-width" nowrap>スコア</th>
                            <th scope="col"></th>
                        </tr>
                        <template v-for="match in getMatches()">
                            <tr>
                                <td rowspan="4" class="align-middle">{{ match.event_id }}<br>{{ match.match_no }}</td>
                                <td rowspan="4" class="align-middle">{{ match.start }}<br><span class="court">{{ match.court }}</span></td>
                                <td class="tbl-team text-start mb-0 pb-0 text-center"><TeamLabelComponent :teamId="match.left_team_id_1" :alterText="match.left_entry_id"/></td>
                                <td class="text-start mb-0 pb-0">{{match.left_player_name_1 }}</td>
                                <td rowspan="2">12 21 21</td>
                                <td rowspan="4"></td>
                            </tr>
                            <tr>
                                <td style="border-top: solid 1px white;" class="text-start mt-0 pt-0 text-center"><template v-if="match.left_team_id_2 != ''"><TeamLabelComponent :teamId="match.left_team_id_2"/></template></td>
                                <td style="border-top: solid 1px white;;" class="text-start mt-0 pt-0">{{ match.left_player_name_2 }}</td>
                            </tr>
                            <!-- <tr>
                                <td style="padding-right:2px; margin:0; width:15px; border-left: none;"><span
                                        v-if="match.left_entry_id == match.winner_entry_id"><font-awesome-icon
                                            :icon="['fas', 'circle-check']" style="color: #32cd32" /></span>b</td>
                                <td>{{ match.left_score }}-{{ match.right_score }}</td>
                            </tr> -->
                            <tr>
                                <td class="text-start mb-0 pb-0 text-center"><TeamLabelComponent :teamId="match.right_team_id_1" :alterText="match.right_entry_id"/></td>
                                <td class="text-start mb-0 pb-0">{{ match.right_player_name_1 }}</td>
                                <td rowspan="2" class="align-top">21 8 19<br><font-awesome-icon :icon="['fas', 'circle-check']" style="color: #32cd32" /></td>
                            </tr>
                            <tr>
                                <td style="border-top: solid 1px white;" class="text-start mt-0 pt-0 text-center"><template v-if="match.right_team_id_2 != ''"><TeamLabelComponent :teamId="match.right_team_id_2"/></template></td>
                                <td style="border-top: solid 1px white;" class="text-start mt-0 pt-0">{{ match.right_player_name_2 }}</td>
                            </tr>

                                <!-- <td style="padding-right:2px; margin:0; width:15px; border-left: none;"><span
                                        v-if="match.left_entry_id == match.winner_entry_id"><font-awesome-icon
                                            :icon="['fas', 'circle-check']" style="color: #32cd32" /></span>a</td>
                                <td>{{ match.left_score }}-{{ match.right_score }}</td>

                            </tr> -->
                        </template>
                    </thead>
                </table>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import TeamLabelComponent from '@/components/TeamLabelComponent.vue';
const matches = ref([]);
// const props = defineProps(['selectedEventId']);
onMounted(() => {
});

const getMatches = () => {
    const allMatches = JSON.parse(localStorage.getItem("matches"))

    const eventRegex = new RegExp('6', "i");

    matches.value = allMatches;

    if (allMatches) {
        
        return Object.fromEntries(
            Object.entries(matches.value).filter(([key, value]) =>
                (eventRegex.test(value.event_id.toLowerCase())))
                .sort(function (a, b) {
                    if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
                    if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
                    if (a[1].court < b[1].court) { return -1 }
                    if (a[1].court > b[1].court) { return 1 }
                    if (a[0] < b[0]) { return -1 }
                    if (a[0] > b[0]) { return 1 }
                    return 0
                })
        );
        // return allMatches.value;
    } else {
        return;
    }

}
</script>

<style scoped>
#result-tbl {
    border-color: #dee2e6;
}
.tbl-team {
    width: 60px;
}
.result-tbl-width {
    width: 80px;
}

.boundary {
    border-bottom: 2px solid #198754;
}

.court {
    display: inline-block;
    font-size: 0.85em;
    padding: 0.0em;
    text-decoration: none;
    background: #d1e7dd;
    /* background: #ff0000; */
    color: black;
    width: 35px;
    margin: 1px;
    text-align: center;
    white-space: nowrap;
    vertical-align: bottom;
}
</style>